<template>
  <div class="order-container">
    <el-tabs v-model="activeTab" type="card" class="order-tab-container">
      <el-tab-pane label="客户信息" name="1">
        <order-tab-content>
          <order-customer :order-detail="orderDetail"/>
        </order-tab-content>
      </el-tab-pane>
      <el-tab-pane label="车辆信息" name="2">
        <order-tab-content>
          <order-car :order-detail="orderDetail"/>
        </order-tab-content>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {hasPer} from "@/utils/common";
import OrderCar from "@/views/order/info/componet/orderCar.vue";
import OrderCustomer from "@/views/order/info/componet/orderCustomer.vue";
import OrderTabContent from "@/views/order/info/tab/orderTabContent.vue";

export default {
  name: "customerTab",
  components: {
    OrderTabContent,
    OrderCustomer,
    OrderCar
  },
  data() {
    return {
      activeTab: '1',
      order: {}
    };
  },
  props: {
    orderDetail: {
      type: Object,
      required: true
    }
  },
  computed: {},
  mounted() {
  },
  created() {
  },
  methods: {
    hasPer
  }
};
</script>

<style scoped>

</style>
